/**
 * LoginPageBackground – simple, elegant: soft gradient and subtle grid only
 */
import React from 'react';
import './LoginPageBackground.scss';

export default function LoginPageBackground() {
  return (
    <div className="login-bg login-bg--simple">
      <div className="login-bg__gradient" />
      <svg className="login-bg__grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
        <defs>
          <pattern id="dotGridSimple" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="20" r="0.8" fill="rgba(255,255,255,0.12)" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dotGridSimple)" />
      </svg>
    </div>
  );
}
